
import { defineStore } from 'pinia'
import { ref, computed, onMounted } from "vue"
import { useRouter, useRoute } from 'vue-router'

export const useDeviceLayout = defineStore('deviceLayout', () => {
    const route = useRoute()
    const router = useRouter()


    const activePreviewDevice = ref('desktop')

    const previewDevices = ref([
        { name: 'desktop', icon: 'monitor02' },
        { name: 'mobile', icon: 'phone02' },
        { name: 'tablet', icon: 'tablet01' },
    ])

    const isMobile = computed(() => activePreviewDevice.value == 'mobile')
    const isTablet = computed(() => activePreviewDevice.value == 'tablet')
    const isDesktop = computed(() => activePreviewDevice.value == 'desktop')

    const previewWidth = computed(() => {
        if (activePreviewDevice.value == 'desktop') return '100%'
        else if (activePreviewDevice.value == 'mobile') return '320px'
        else if (activePreviewDevice.value == 'tablet') return '475px'
    })

    // change device & update url
    const changePreviewDevice = (device) => {
        activePreviewDevice.value = device

        // Note: Do not remove setTimeout. Conflict with multiple route push in same time.
        setTimeout(() => {
            router.push({
                query: {
                    ...route.query,
                    device: activePreviewDevice.value,
                }
            })
        }, 200)
    }

    const setActiveDevice = (device) => {
        if (!device) return

        activePreviewDevice.value = device
        changePreviewDevice(activePreviewDevice.value)
    }

    onMounted(() => {
        if (route.query.device) {
            setActiveDevice(route.query.device)
        } else {
            setActiveDevice('desktop')
        }
    })

    return { activePreviewDevice, setActiveDevice, previewDevices, previewWidth, changePreviewDevice, isMobile, isTablet, isDesktop }
})
